import React from "react";
import { Link } from "react-router-dom";
import { hexToRgba } from "../../design-tokens";
import styles from "./ReportDashboard.module.css";

export interface DashCardProps {
  to: string;
  icon: string;
  accent: string;
  title: string;
  value: string;
  unit?: string;
  sub?: React.ReactNode;
  /** Rótulo do link no rodapé ("Ver no Sinótico" etc.). */
  foot: string;
}

const DashCard: React.FC<DashCardProps> = ({ to, icon, accent, title, value, unit, sub, foot }) => (
  <Link to={to} className={styles.dashCard}>
    <div className={styles.dashHead}>
      <span className={styles.dashIcon} style={{ background: hexToRgba(accent, 0.14), color: accent }}>
        <span className="material-symbols-outlined">{icon}</span>
      </span>
      <span className={styles.dashTitle}>{title}</span>
    </div>
    <div className={styles.dashValueRow}>
      <span className={styles.dashValue}>{value}</span>
      {unit && <span className={styles.dashUnit}>{unit}</span>}
    </div>
    {sub != null && <div className={styles.dashSub}>{sub}</div>}
    <span className={styles.dashFoot}>
      {foot}
      <span className="material-symbols-outlined">arrow_forward</span>
    </span>
  </Link>
);

export default DashCard;
